import React, { useEffect, useState } from "react";
import TrendingSvg from "../../images/icons/trending.svg";
import "./promotion.css";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { promotionsBreakPoints } from "../../constants/constant";
import PromotionCard from "./PromotionCard";
import { fetch_all_propmotions } from "../../actions/promotions/promotion";
import RedirectCommonModal from "../../components/alert/RedirectCommonModal";

const Promotion = (props) => {
  const { menuVisibility, promotionList } = props;
  const hotelId = localStorage.getItem("hotel-id");
  const [alert, setAlert] = useState("");

  

  const alertMsg = (msg) => {
    setAlert(msg);
  };
   return (
    <>
      {promotionList.length ? (
        <div className="promotion-section mb-3">
          <div>
            <div className="flex items-center justify-between">
              <div className="flex mt-3 promo-head gap-3 mb-3">
                Offers for you
              </div>
            {promotionList?.length > 1 && 
             <Link
                to="../offers"
                state={{
                  promotionList: promotionList,
                  menuVisibility: menuVisibility,
                }}
                className="see-all"
              >
                See all
              </Link>}
            </div>
            <Carousel responsive={promotionsBreakPoints}>
              {promotionList.map((item, i) => (
                <PromotionCard
                  key={i}
                  menuVisibility={menuVisibility}
                  data={item}
                  alertMsg={(msg) => alertMsg(msg)}
                  isFuture={item.is_future}
                  startDate={item.startDate}
                />
              ))}
            </Carousel>
          </div>
          {alert && (
            <RedirectCommonModal para={alert} hide={() => setAlert("")} />
          )}
        </div>
      ) : null}
    </>
  );
};

export default Promotion;
